// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-profile {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  color: var(--vb-text);
}

.user-profile header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  background: color-mix(in srgb, var(--vb-surface) 88%, transparent);
  border-bottom: 1px solid var(--vb-border);
}

.user-profile h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  text-align: left;
}

.user-profile .button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.user-profile .control-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--vb-surface);
  color: var(--vb-text);
  border: 1px solid var(--vb-border);
  padding: 8px 12px;
  min-height: 40px;
  border-radius: var(--vb-radius-sm);
  font-weight: 650;
}

.user-profile .main-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 16px;
}

.user-profile form {
  width: 100%;
  max-width: 440px;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius);
  padding: 24px;
  box-shadow: var(--vb-shadow-sm);
  box-sizing: border-box;
}

.form-group {
  margin-bottom: 14px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  color: var(--vb-text-muted);
  font-size: 13px;
  font-weight: 650;
}

.form-group input {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid var(--vb-border-strong);
  border-radius: var(--vb-radius-sm);
  font-size: 16px;
  background: var(--vb-surface-2);
  color: var(--vb-text);
}

.form-group input:disabled {
  opacity: 0.7;
}

.update-button {
  display: block;
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: var(--vb-radius-sm);
  font-size: 16px;
  font-weight: 750;
  cursor: pointer;
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
  margin-top: 8px;
}

.message-container {
  width: 100%;
  max-width: 440px;
  text-align: center;
  margin-bottom: 16px;
}

.success-message,
.error-message {
  display: block;
  padding: 10px 12px;
  border-radius: 10px;
  font-weight: 650;
}

.success-message {
  background: var(--vb-success-soft);
  color: var(--vb-success);
}

.error-message {
  background: var(--vb-danger-soft);
  color: var(--vb-danger);
}
`, "",{"version":3,"sources":["webpack://./src/components/UserProfile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kEAAkE;EAClE,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,kCAAkC;EAClC,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB","sourcesContent":[".user-profile {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  color: var(--vb-text);\n}\n\n.user-profile header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  background: color-mix(in srgb, var(--vb-surface) 88%, transparent);\n  border-bottom: 1px solid var(--vb-border);\n}\n\n.user-profile h1 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 800;\n  text-align: left;\n}\n\n.user-profile .button-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.user-profile .control-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border);\n  padding: 8px 12px;\n  min-height: 40px;\n  border-radius: var(--vb-radius-sm);\n  font-weight: 650;\n}\n\n.user-profile .main-content {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 28px 16px;\n}\n\n.user-profile form {\n  width: 100%;\n  max-width: 440px;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius);\n  padding: 24px;\n  box-shadow: var(--vb-shadow-sm);\n  box-sizing: border-box;\n}\n\n.form-group {\n  margin-bottom: 14px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--vb-text-muted);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.form-group input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 12px 14px;\n  border: 1px solid var(--vb-border-strong);\n  border-radius: var(--vb-radius-sm);\n  font-size: 16px;\n  background: var(--vb-surface-2);\n  color: var(--vb-text);\n}\n\n.form-group input:disabled {\n  opacity: 0.7;\n}\n\n.update-button {\n  display: block;\n  width: 100%;\n  padding: 12px;\n  border: none;\n  border-radius: var(--vb-radius-sm);\n  font-size: 16px;\n  font-weight: 750;\n  cursor: pointer;\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n  margin-top: 8px;\n}\n\n.message-container {\n  width: 100%;\n  max-width: 440px;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.success-message,\n.error-message {\n  display: block;\n  padding: 10px 12px;\n  border-radius: 10px;\n  font-weight: 650;\n}\n\n.success-message {\n  background: var(--vb-success-soft);\n  color: var(--vb-success);\n}\n\n.error-message {\n  background: var(--vb-danger-soft);\n  color: var(--vb-danger);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
